import { create } from "zustand";

/**
 * Глобальный стор «доступно обновление SPA».
 *
 * Заполняется хуком `useAppVersion`, когда polling `/version.json`
 * обнаруживает новый `sha`. Читается компонентом `<UpdateBanner />` и
 * route-listener'ом в TanStack Router (auto-reload на навигации).
 *
 * Поля:
 *  - `available` — обнаружена новая версия. Активирует баннер.
 *  - `forceReload` — критическое обновление: баннер без кнопки, авто-reload
 *    через 5 секунд. Берётся из `version.json.forceReload`.
 *  - `newSha` — sha обнаруженной версии (для логирования и e2e-тестов).
 */
interface AppUpdateState {
	available: boolean;
	forceReload: boolean;
	newSha: string | null;
	setUpdate: (params: { sha: string; forceReload?: boolean }) => void;
	reset: () => void;
}

export const useAppUpdateStore = create<AppUpdateState>((set, get) => ({
	available: false,
	forceReload: false,
	newSha: null,

	setUpdate({ sha, forceReload = false }) {
		const state = get();
		// No-op guard: не нотифицируем подписчиков повторно на ту же версию.
		// Polling может вернуть один и тот же sha много раз до reload.
		if (state.available && state.newSha === sha && state.forceReload === forceReload) {
			return;
		}
		set({ available: true, forceReload, newSha: sha });
	},

	reset() {
		set({ available: false, forceReload: false, newSha: null });
	},
}));
